
<template>
  <div class="wrapper">
    <div class="cell">
      <i @click="play" class="material-icons play-control">{{playIcon}}</i>
      <i @click="toggleVolume" class="material-icons volume-toggle-control">{{volumeToggleIcon}}</i>
      <i
        @click="toggleOverlay"
        style="margin: 0 2px"
        class="material-icons toggle-overlay-control"
      >{{overlayIcon}}</i>
      <i
        @click="onPlaybackRateChanged"
        style="margin: 0 2px 0 0"
        class="material-icons playback-rate-control"
      >{{playbackRateIcon}}</i>
      <i
        @click="toggleBar"
        style="margin: 0 2px 0 0"
        class="material-icons toggle-scrubbar-control"
      >more_horiz</i>
    </div>
    <div v-if="showBar" class="scenebar">
      <div class="scenebar__wrapper">
        <div class="scenebar__progress" @click="onProgressClicked">
          <div class="scenebar__progress-track"></div>
          <div class="scenebar__progress-fill" :style="progressFill"></div>
        </div>
        <span
          class="scenebar-item"
          v-for="(scene, index) in scenes"
          :key="scene.id"
          :title="scene.type"
          :class="scene.clz"
          :style="{'left': scene.leftPos}"
          @click="onSceneItemClicked(scene)"
        >
          <i class="material-icons">{{ scene.icon }}</i>
        </span>
      </div>
    </div>
    <div class="cell controls-right">
      <div
        v-if="hasSubtitles"
        class="cell subtitles-cell"
        :class="{'is-selected': isSubtitlesShow}"
      >
        <i style="margin: 0 0 0 2px" @click="setSubtitles" class="material-icons">subtitles</i>
      </div>
      <div class="cell langs-cell" @click="toggleLang">
        <ul class="langs" :class="{'is-visible': languageToggleOn}">
          <li
            v-for="lang in languages"
            :key="'lang-' + lang"
            @click.stop="selectLang(lang)"
          >{{ lang }}</li>
        </ul>
        <span class="selected-lang">{{ selectedLanguage }}</span>
      </div>
      <div class="cell fullscreen">
        <i style="margin: 0 0 0 2px" @click="fullscreen" class="material-icons">fullscreen</i>
      </div>
    </div>
  </div>
</template>

<script>
import { base } from "./mixins/multilang";

export default {
  name: "controls",
  mixins: [base],
  props: {
    tags: Array,
    videoDuration: Number,
    showScrubbar: Boolean,
    showSubtitles: Boolean,
    isPlaying: Boolean,
    hasSubtitles: Boolean,
    videoId: {
      type: String,
      default: function() {
        return null;
      }
    }
  },
  mounted() {
    console.log("controls mounted", this.tags, this.videoId);
    this.duration = this.videoDuration;
    this.monitorProgress(true);
    this.videoElement = document.getElementById(this.videoId);
    this.showBar = this.showScrubbar;
    this.isSubtitlesShow = this.showSubtitles;
    // init
    this.onChangeIsPlaying(this.isPlaying);
  },
  beforeDestroy() {
    this.monitorProgress(false);
  },
  data() {
    return {
      playIcon: "stop",
      overlayIcon: "check_box",
      volumeToggleIcon: "volume_up",
      playing: true,
      muted: false,
      showOverlay: true,
      duration: 0,
      showBar: false,
      currentTime: 0,
      playbackRates: [1, 0.5, 2],
      playbackRateIndex: 0,
      playbackRateIcons: ["schedule", "slow_motion_video", "timelapse"],
      languageToggleOn: false,
      isSubtitlesShow: false
    };
  },
  watch: {
    videoDuration: "onVideoDurationChanged",
    isPlaying: "onChangeIsPlaying"
  },
  computed: {
    scenes: function() {
      var scenes = [];
      var markers = [];

      if (this.duration === 0) {
        return scenes;
      }
      for (var i = 0; i < this.tags.length; i++) {
        var tag = this.tags[i];
        for (var k = 0; k < tag.scenes.length; k++) {
          var scene = tag.scenes[k];
          var time = scene.waypoints[0].time;
          scenes.push({
            time: time,
            icon: tag.meta.icon || "lens",
            type: tag.template,
            clz: tag.meta.icon ? "is-" + tag.meta.icon : "",
            leftPos: (time / this.duration) * 100 + "%"
          });
        }
      }
      scenes = scenes.sort(this.sortByTime);
      markers = scenes.filter(scene => scene.type === "markerTag");
      console.log("computed scenes", scenes);
      if (markers.length > 0) {
        return markers;
      } else {
        return scenes;
      }
    },
    progressFill: function() {
      var fp = 100 - (this.currentTime / this.videoDuration) * 100;
      return {
        transform: "translateX(-" + fp + "%)"
      };
    },
    playbackRateIcon: function() {
      return this.playbackRateIcons[this.playbackRateIndex];
    }
  },
  methods: {
    play() {
      if (!this.isPlaying) {
        this.$emit("play");
      } else {
        this.$emit("pause");
      }
    },
    onChangeIsPlaying(newVal, oldVal) {
      console.log("onChangeIsPlaying", newVal);
      this.playIcon = newVal ? "stop" : "play_arrow";
    },
    toggleVolume() {
      console.log("toggleVolume");
      if (!this.muted) {
        this.$emit("mute", true);
        this.volumeToggleIcon = "volume_off";
      } else {
        this.$emit("mute", false);
        this.volumeToggleIcon = "volume_up";
      }
      this.muted = !this.muted;
    },
    toggleOverlay() {
      if (this.showOverlay) {
        this.$emit("overlay", false);
        this.overlayIcon = "indeterminate_check_box";
      } else {
        this.$emit("overlay", true);
        this.overlayIcon = "check_box";
      }
      this.showOverlay = !this.showOverlay;
    },
    fullscreen() {
      this.$emit("fullscreen");
    },
    sortByTime(a, b) {
      if (a.time < b.time) {
        return -1;
      } else if (a.time > b.time) {
        return 1;
      }
      return 0;
    },
    onVideoDurationChanged(newVal, oldVal) {
      this.duration = newVal;
    },
    onSceneItemClicked(scene) {
      this.$emit("play", scene.time);
    },
    toggleBar() {
      this.showBar = !this.showBar;
    },
    monitorProgress(doit) {
      clearInterval(this.monitorIntervalId);
      if (doit) {
        this.monitorIntervalId = setInterval(() => {
          this.currentTime = this.videoElement.currentTime;
          // console.log('currentTime', this.currentTime)
        }, 250);
      }
    },
    onProgressClicked(ev) {
      var bb = ev.currentTarget.getBoundingClientRect();
      var ox = (ev.clientX - bb.left) / (bb.right - bb.left);
      var pp = ox * this.videoDuration;
      this.$emit("play", pp);
    },
    onPlaybackRateChanged() {
      this.playbackRateIndex = this.playbackRateIndex + 1;
      if (this.playbackRateIndex >= this.playbackRates.length) {
        this.playbackRateIndex = 0;
      }
      this.videoElement.playbackRate = this.playbackRates[
        this.playbackRateIndex
      ];
    },
    selectLang(lang) {
      console.log("selectLang", lang);
      var textTracks = this.videoElement.textTracks;
      for (var i = 0; i < textTracks.length; i++) {
        textTracks[i].mode =
          this.isSubtitlesShow && textTracks[i].language === lang
            ? "showing"
            : "disabled";
      }
      // see mixin
      this.languageToggleOn = false;
      this.changeLanguage(lang);
    },
    setSubtitles() {
      this.isSubtitlesShow = !this.isSubtitlesShow;
      var textTracks = this.videoElement.textTracks;
      for (var i = 0; i < textTracks.length; i++) {
        textTracks[i].mode =
          this.isSubtitlesShow &&
          textTracks[i].language === this.selectedLanguage
            ? "showing"
            : "disabled";
      }
    },
    toggleLang() {
      this.languageToggleOn = !this.languageToggleOn;
    }
  }
};
</script>

<style scoped lang="scss">
.wrapper {
  display: flex;
  justify-content: space-between;
}

.cell {
  display: inline-flex;
  i {
    user-select: none;
    cursor: pointer;
    padding: 4px;
    background: #efefef;
    &:hover,
    &:active {
      background-color: #afafaf;
    }
  }
  &.langs-cell {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    font-size: 10pt;
    text-transform: uppercase;
    cursor: pointer;
    text-align: center;
    padding: 5pt;
    .langs {
      display: none;
      position: absolute;
      bottom: 100%;
      width: 100%;
      list-style-type: none;
      padding-inline-start: 0;
      margin-block-end: 0;
      text-transform: uppercase;
      background-color: rgba(255, 255, 255, 0.25);
      li {
        padding: 5pt;
      }

      &.is-visible {
        display: block;
      }
    }
  }
  &.subtitles-cell {
    border-bottom: 2px solid transparent;
    &.is-selected {
      border-bottom: 2px solid red;
    }
  }
}

.scenebar {
  padding: 0 1em; // border: 1px solid red;
  flex-grow: 10;
  height: 32px;
  width: 100%;
  background-color: #efefef;
  &__wrapper {
    position: relative;
    background-color: #fafafa; // border: 1px solid yellow;
    height: 100%;
    width: 100%;
    .scenebar-item {
      display: block;
      position: absolute;
      top: 50%;
      margin-top: -11px;
      margin-left: -11px;
      width: 22px;
      height: 22px;
      color: rgba(92, 92, 92, 1);
      cursor: pointer;
      &.is-lens {
        color: rgba(92, 92, 92, 1);
        &:hover {
          filter: hue-rotate(1);
        }
      }
      &.is-warning {
        color: orange;
        &:hover {
          filter: hue-rotate(1);
        }
      }
      &.is-place {
        color: forestgreen;
        &:hover {
          filter: hue-rotate(1);
        }
      }
      &.is-report {
        color: red;
        &:hover {
          filter: hue-rotate(1);
        }
      }
      &.is-info {
        color: skyblue;
        &:hover {
          filter: hue-rotate(1);
        }
      }
      &.is-live_help {
        color: skyblue;
        &:hover {
          filter: hue-rotate(1);
        }
      }
      i.material-icons {
        background-color: white;
        font-size: 22px;
        border-radius: 50%;
        box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.25);
        &:hover {
          box-shadow: 0px 3px 2px 0px rgba(0, 0, 0, 0.25);
        }
      }
    }
  }
  &__progress {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  &__progress-track,
  &__progress-fill {
    position: absolute;
    top: 50%;
    height: 2px;
    margin-top: -1px;
    background-color: #ccc;
    width: 100%;
  }
  &__progress-fill {
    // background-color: red;
    width: 100%;
    transform: translateX(-10%);
    transition: transform 0.1s linear;
  }
}
</style>
